import store from "../store";
import roles from "./roles";
import * as _ from "lodash";

export default {
  methods: {
    isTeamLead: function (teamMembers, user) {
      return _.filter(teamMembers, member => {
        return (
          member.asuriteId === user &&
          member.translationalTeamRole.name.includes("Lead")
        );
      }).length;
    }
  },
  computed: {
    canEditTeam: function () {
      var members = this.translationalTeam
        ? this.translationalTeam.translationalTeamMembers
        : [];
      return (
        this.isTranslationalTeamAdmin ||
        (this.isTranslationalTeamManager &&
          this.isTeamLead(members, this.$store.state.auth.user.userId))
      );
    },
    isImpersonation: function () {
      return store.getters.isAuthorized(roles.impersonation);
    },
    isFacultyHead: function () {
      return store.getters.isAuthorized(roles.facultyHead);
    },
    isEmployee: function () {
      return store.getters.isAuthorized(roles.employee);
    },
    isDegreeCoordinator: function () {
      return store.getters.isAuthorized(roles.degreeCoordinator);
    },
    isViewOnly: function () {
      return store.getters.isAuthorized(roles.viewOnly);
    },
    isExpertsEditor: function () {
      return store.getters.isAuthorized(roles.expertsEditor);
    },
    isExpertsAdmin: function () {
      return store.getters.isAuthorized(roles.expertsAdmin);
    },
    isTranslationalTeam: function () {
      return store.getters.isAuthorized(roles.translationalTeam);
    },
    isTranslationalTeamAdmin: function () {
      return store.getters.isAuthorized(roles.translationalTeamAdmin);
    },
    isTranslationalTeamManager: function () {
      return store.getters.isAuthorized(roles.translationalTeamManager);
    },
    // Marina, August 11, 2022
    isTranslationalTeamViewer: function () {
      return store.getters.isAuthorized(roles.translationalTeamViewer);
    },
    isExpertsViewer: function () {
      return store.getters.isAuthorized(roles.expertsViewer);
    },
    isPlacementsUser: function () {
      return (
        store.getters.isAuthorized(roles.placementsAdvisor) ||
        store.getters.isAuthorized(roles.placementsContractManager) ||
        store.getters.isAuthorized(roles.placementsFaculty) ||
        store.getters.isAuthorized(roles.placementsViewer)
      );
    },
    isWorkloadsUser: function () {
      return (
        store.getters.isAuthorized(roles.workloadFacultyHead) ||
        store.getters.isAuthorized(roles.workloadEmployee) ||
        store.getters.isAuthorized(roles.workloadDegreeCoordinator) ||
        store.getters.isAuthorized(roles.workloadViewOnly)
      );
    },
    isExpertsUser: function () {
      return (
        store.getters.isAuthorized(roles.expertsEditor) ||
        store.getters.isAuthorized(roles.expertsAdmin) ||
        store.getters.isAuthorized(roles.expertsViewer)
      );
    },
    canViewAwards: function () {
      return (
        store.getters.isAuthorized(roles.awardsViewer) ||
        store.getters.isAuthorized(roles.awardsManager)
      );
    },
    canViewProposals: function () {
      return (
        store.getters.isAuthorized(roles.proposalsManager) ||
        store.getters.isAuthorized(roles.proposalsViewer)
      );
    },
    canViewProjects: function () {
      return (
        store.getters.isAuthorized(roles.projectsViewer) ||
        store.getters.isAuthorized(roles.projectsManager)
      );
    },
    canViewCommunityPartners: function () {
      return (
        store.getters.isAuthorized(roles.cpManager) ||
        store.getters.isAuthorized(roles.cpViewer)
      );
    },
    canViewStudentOpportunities: function () {
      return store.getters.isAuthorized(roles.placementsStudentManager);
    },

    isCommunityPartnersManger: function () {
      return store.getters.isAuthorized(roles.cpManager);
    },

    isProjectsManager: function () {
      return store.getters.isAuthorized(roles.projectsManager);
    },

    isProposalsManager: function () {
      return store.getters.isAuthorized(roles.proposalsManager);
    },

    isAwardsManager: function () {
      return store.getters.isAuthorized(roles.awardsManager);
    },

    isEmployeesManager: function () {
      return store.getters.isAuthorized(roles.employeesManager);
    },
    isOpportunitiesManager: function () {
      return store.getters.isAuthorized(roles.opportunitiesManager);
    },
    isStudentPlacementsManager: function () {
      return store.getters.isAuthorized(roles.studentPlacementsManager);
    }
  }
};
